<template>
  <q-input
    v-model="model"
    :placeholder="placeholder"
    :disabled="true"
    :width="width"
  />
</template>
<script>

  import inputMixin from "./inputMixin";

  export default {
    name: 'QLabel',
    mixins:[inputMixin],
    props:{
      width: {default: '150'}
    }
  };
</script>
